// extracted by mini-css-extract-plugin
export default {"title":"WarningModal_title__MJ2HB","customHeader":"WarningModal_customHeader__dPVgX","customBody":"WarningModal_customBody__JYCIp","customFooter":"WarningModal_customFooter__30hjA"};